const Utils = function($) {
	return {
		countDown: function(tag, timeStart, timeEnd,allTimeEnd, promptTitle, countDownFlag, countDownFlagValue, countDownFlagTime) {

			const day = globalFunction.getDateStringByDateAndZone('America/Los_Angeles', new Date()),
				  times = globalFunction.getTimeStringByDateAndZone('America/Los_Angeles', new Date()),
				  us_time = new Date(day + ' ' + times).getTime(),
				  timeNow = parseInt(us_time / 1000);
 
            if(timeNow < allTimeEnd){
              if (timeEnd >= timeNow && timeNow >= timeStart) {
                  let time = globalFunction.getDiffTime(timeEnd - timeNow);
                  for (var t = 0; t < tag.find('.timer').length; t++) {
                      tag.find(' .count-down-time .timer').eq(t).text(time.slice(t * 2, (t + 1) * 2));
                  }
                  if((window.location.pathname).indexOf('/product') != -1){
                     $('#timer-message').text(promptTitle);

                     $('#top-description').hide();
                     $('.product-stock').css('display','block')
                  }else{
//                     var __price = (tag.siblings('.money-styling').find('.money-styling .money .money').text())
//                     console.log(__price)
//                     var _collection_product_new_price = '<span style="display: none; color: #A90000;font-weight: bold;">New Price:</span><span class="money">qwww</span>'
//                     tag.siblings('.new-price').html(_collection_product_new_price)
                  	tag.find('p').text('Sale Ends In');
                    tag.find('ul li').css({
                    'border-color':'#A90000' ,
                    'color':'#A90000'
                  });
                  }
                  tag.show();
                  window.setTimeout(function() {
                      Utils.countDown(tag, timeStart, timeEnd, allTimeEnd,promptTitle, countDownFlag,countDownFlagValue, countDownFlagTime)
                  }, 1000)
              }else if(timeNow < timeStart){
                
                
                
                let time = globalFunction.getDiffTime(timeStart - timeNow);

                  for (var t = 0; t < tag.find('.timer').length; t++) {
                      tag.find('.count-down-time .timer').eq(t).text(time.slice(t * 2, (t + 1) * 2));
                  }
                  
                  
                
                if((window.location.pathname).indexOf('/product') != -1){
                  $('#top-description').hide();
                  let _price_html = '<p style="margin-top: -20px;margin-bottom: 0;font-size: 20px; color: #a90000;font-family: Montserrat,sans-serif;">Clearance Price: $ ???</p>'
 					          					$('.cyber-monday').html(_price_html)

                  $('#timer-message').text(promptTitle);
                  tag.find('ul li').css('background','#7f7f7f')
                  $('#timer-message').text('Sale Starts In');
                  $('.product-stock').css('display','none')
                  tag.show();

                  

                }else{
                  tag.find('p').text('Sale Starts in')
                  
                  tag.find('ul li').css({
                    'border-color':'rgb(127, 127, 127)' ,
                    'color':'rgb(127, 127, 127)'
                  });
                  tag.show();
                  
                }
                window.setTimeout(function() {
                      Utils.countDown(tag, timeStart, timeEnd, allTimeEnd,promptTitle, countDownFlag,countDownFlagValue, countDownFlagTime)
                  }, 1000)
              }else {
                if((window.location.pathname).indexOf('/product') != -1){
                  
                  $('#timer-message').text('Sale Ended');
                  tag.find('ul').hide();
                  tag.show();

                  $('.product-stock').css('display','none')

                }else{
                  
                  tag.find('ul').html('');
                  tag.find('p').text('Sale Ended')
                  tag.show();

                }
              }
            }else{
            	tag.hide();
            }
		},
		//     设置产品的薄厚
		getThick: function() {
			const variantSku = [29433469272158, 29433469993054, 29433469567070];

			for (var i = 0; i < variantSku.length; i++) {
				if (window.location.search.split('?variant=')[1] == variantSku[i]) {
					$('h1.product-description-header').text("Men's Wool Blend Pea Coat Winter Jackets-Thick");
					break;
				} else {
					$('h1.product-description-header').text("Men's Wool Blend Pea Coat Winter Jackets")
				}
			}
		},
      


	}
}(window.wetheme.$);
